import { render } from "./Alertbox.vue?vue&type=template&id=47693498"
import script from "./Alertbox.vue?vue&type=script&lang=js"
export * from "./Alertbox.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__